<template>
  <div class="container-opern">
    <div class="mwow-button-filled warning" @click="showDialog">
      <slot></slot>
    </div>
    <el-dialog
      title="物品服务"
      :visible="dialogVisible"
      @close="handleCloseDialog"
    >
      <common-search-form-wrapper :hiddenExpand="true" :reset="handleReset">
        <el-form
          size="mini"
          ref="form"
          :model="searchInfo"
          label-width="50px"
          class="mwow-form"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="名称:" prop="title">
                <el-input
                  v-model="searchInfo.title"
                  placeholder="物品名称"
                  @change="handleSearch"
                  prefix-icon="el-icon-search"
                  clearable
                  maxlength="99"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="类型:" prop="category_id">
                <el-select
                  v-model.number="searchInfo.category_id"
                  placeholder="请选择"
                  @change="handleSearch"
                >
                  <el-option
                    v-for="item in categoryList"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </common-search-form-wrapper>
      <el-table
        size="mini"
        v-horizontal-scroll
        :data="tableData"
        stripe
        style="width: 100%; margin-top: 20px"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="名称" prop="title"> </el-table-column>
        <el-table-column label="类型" prop="category_id">
          <template slot-scope="scope">
            <span v-if="scope.row.category_id === 1">物品</span>
            <span v-if="scope.row.category_id === 2">服务</span>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          width="240"
          prop="create_time"
        ></el-table-column>
      </el-table>
      <div style="overflow: hidden">
        <el-pagination
          :current-page="page"
          :page-size="pageSize"
          :page-sizes="pageSizeArray"
          :style="{ float: 'right', padding: '20px' }"
          :total="total"
          @current-change="handlePagerChange"
          @size-change="handlePagerSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
      <div style="text-align: right">
        <div
          class="mwow-button-filled"
          style="margin-right: 10px"
          @click="handleCloseDialog"
        >
          取消
        </div>
        <div class="mwow-button-filled success" @click="handleSubmit">确定</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import commonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import { dateFormat } from "@/utils/timeFormat";
import { getProductListApi } from "@/api/product";
export default {
  components: {
    commonSearchFormWrapper,
  },
  data() {
    return {
      searchInfo: {
        title: "",
        category_id: "",
      },
      categoryList: [
        { key: 1, value: "物品" },
        { key: 2, value: "服务" },
      ],
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      dialogVisible: false,
      multipleSelection: [],
    };
  },
  methods: {
    showDialog() {
      this.dialogVisible = true;
      this.handleSearch();
    },
    solveSearchParams(options) {
      let params = { ...options };
      if (this.searchInfo.title) {
        params.title = this.searchInfo.title;
      }
      if (this.searchInfo.category_id) {
        params.category_id = this.searchInfo.category_id;
      }
      return params;
    },
    getList(options) {
      let params = this.solveSearchParams(options);
      getProductListApi(params).then((res) => {
        res.data.list.map((item) => {
          item.create_time =
            item.create_time === 0
              ? "-"
              : dateFormat("YYYY-mm-dd HH:MM", item.create_time * 1000);
        });
        this.tableData = res.data.list;
        this.page = res.data.page;
        this.total = res.data.total;
      });
    },
    handleReset() {
      this.searchInfo = {
        title: "",
        category_id: "",
      };
      this.handleSearch();
    },
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handleRefresh() {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    handleSelectionChange(arr) {
      this.multipleSelection = arr;
    },
    handleCloseDialog() {
      this.dialogVisible = false;
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    handleSubmit() {
      this.$emit("change", this.multipleSelection);
      this.handleCloseDialog();
    },
  },
};
</script>
<style lang="scss" scoped></style>
